// frontend/src/services/tareasService.js

import api from './api';

const tareasService = {
  /**
   * Obtiene la lista de tareas con filtros opcionales
   * GET /api/content/tareas/
   */
  getTareas: async (filtros = {}) => {
    try {
      const response = await api.get('/tareas/', { params: filtros });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Obtiene una tarea específica por ID
   * GET /api/content/tareas/:id/
   */
  getTarea: async (id) => {
    try {
      const response = await api.get(`/tareas/${id}/`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Crea una nueva tarea
   * POST /api/content/tareas/
   */
  crearTarea: async (datosTarea) => {
    try {
      const response = await api.post('/tareas/', datosTarea);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Actualiza una tarea existente
   * PUT /api/content/tareas/:id/
   */
  actualizarTarea: async (id, datosTarea) => {
    try {
      const response = await api.put(`/tareas/${id}/`, datosTarea);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Actualiza parcialmente una tarea
   * PATCH /api/content/tareas/:id/
   */
  actualizarParcialTarea: async (id, datosTarea) => {
    try {
      const response = await api.patch(`/tareas/${id}/`, datosTarea);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Elimina una tarea
   * DELETE /api/content/tareas/:id/
   */
  eliminarTarea: async (id) => {
    try {
      const response = await api.delete(`/tareas/${id}/`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Obtiene las tareas asignadas al usuario actual
   * GET /api/content/tareas/my_tasks/
   */
  getMisTareas: async () => {
    try {
      const response = await api.get('/tareas/my_tasks/');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Inicia el cronómetro de una tarea
   * POST /api/content/tareas/:id/start_timer/
   */
  iniciarCronometro: async (id) => {
    try {
      const response = await api.post(`/tareas/${id}/start_timer/`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Detiene el cronómetro de una tarea
   * POST /api/content/tareas/:id/stop_timer/
   */
  detenerCronometro: async (id) => {
    try {
      const response = await api.post(`/tareas/${id}/stop_timer/`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Marca una tarea como completada
   * POST /api/content/tareas/:id/mark_completed/
   */
  marcarCompletada: async (id) => {
    try {
      const response = await api.post(`/tareas/${id}/mark_completed/`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Obtiene los time logs de una tarea específica
   * GET /api/content/tarea-timelogs/?tarea=:id
   */
  getTimeLogs: async (tareaId) => {
    try {
      const response = await api.get('/tarea-timelogs/', {
        params: { tarea: tareaId }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default tareasService;
